// extracted by mini-css-extract-plugin
export var button = "_15-0";
export var buttonContent = "_15-e";
export var buttonGroup = "_15-c";
export var dontRestrainIconWidth = "_15-a";
export var dropdownButton = "_15-b";
export var iconContainer = "_15-9";
export var lg = "_15-4";
export var md = "_15-3";
export var pending = "_15-f";
export var sm = "_15-2";
export var spinner = "_15-d";
export var squared = "_15-8";
export var wrapText = "_15-g";
export var xl = "_15-5";
export var xs = "_15-1";
export var xxl = "_15-6";
export var xxxl = "_15-7";